import "./AccessLevelListTableComponent.scss";
import {ITableColumn} from "../../../../shared/models/table.model";
import React, {useMemo} from "react";
import commonService from "../../../../shared/services/common.service";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../constants";
import {Link} from "react-router-dom";
import {CommonService} from "../../../../shared/services";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TooltipComponent from "../../../../shared/components/tooltip/tooltipComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";

interface AccessLevelListTableComponentProps {
    filterData?: {};
    isColumnFilterVisible: boolean
}

const AccessLevelListTableComponent = (props: AccessLevelListTableComponentProps) => {
    const {filterData} = props;
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const columns: ITableColumn[] = useMemo<any>(() => [
        {
            id: 'role',
            label: 'Role Name',
            width: "250",
            fixed: 'left'
        },
        {
            id: 'modules',
            label: 'Module(s) Access',
            content: (row: any) => {
                const str = row?.acl?.map((item: any) => item).join(', ');
                if (str.length < 70) {
                    return commonService.capitalizeFirstLetterOfEachWord(str);
                } else {
                    return (
                        <TooltipComponent
                            tooltip={commonService.capitalizeFirstLetterOfEachWord(str)}
                            placement="top"
                            arrow={true}>
                            <div className={'access-modules-tooltip'}>
                                {commonService.capitalizeFirstLetterOfEachWord(str)}
                            </div>
                        </TooltipComponent>
                    )
                }

            }
        },
        {
            id: 'updated',
            label: 'Last Updated On',
            align: 'center',
            content: (row: any) => {
                if (row?.lastUpdateOn) {
                    return commonService.formatDate(row?.lastUpdateOn)+ '  |  ' + commonService.formatTime(row?.lastUpdateOn);
                } else {
                    return '-';
                }
            }
        },
        {
            id: 'actions',
            label: '',
            fixed: "right",
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            align: 'center',
            width: commonService.checkAccess('AccessControl', 'accessControlEdit', currentUser?.userAccessModules) ? "100" : "0",
            content: (item: any, index: any) => (
                <React.Fragment>
                    {
                        commonService.checkAccess('AccessControl', 'accessControlEdit', currentUser?.userAccessModules) ?

                            <div className="table-actions" id={`view_acl_role_` + index}>
                                <Link
                                    to={CommonService._routeConfig.AccessLevelRoleDetailsRoute(item?.id, item?.role, item?.lastUpdateOn)}>
                                    <div className="table-action">
                                        <ChevronRightIcon/>
                                    </div>
                                </Link>
                            </div>:
                            <></>
                    }
                </React.Fragment>
            )
        }
    ], [currentUser]);

    return (
        <div className={'access-level-list-table-component table-list-container'}>
            <TableWrapperV2Component
                isPaginated={false}
                columns={columns}
                url={APIConfig.GET_ACCESS_LEVEL_LIST.URL}
                method={APIConfig.GET_ACCESS_LEVEL_LIST.METHOD}
                extraPayload={filterData}
                isColumnFilterVisible={false}
            />
        </div>
    );

};

export default AccessLevelListTableComponent;
